import { H2, NoteData, QuestionAnswerLayout } from "~/common/components";
import { CheckInWithAnswers, TeamMember } from "~/common/utils";

interface ScheduledAppointmentProps {
  details?: CheckInWithAnswers;
  provider?: TeamMember;
}

export const ScheduledAppointment = ({
  details,
  provider,
}: ScheduledAppointmentProps) => {
  const { note, extra_data } = details ?? {};

  const duration = extra_data?.duration.replace("min", "minute");

  return (
    <div className="flex w-full flex-col gap-4 overflow-auto">
      <H2>Schedule appointment</H2>
      <div className="flex flex-col gap-4">
        {note && (
          <NoteData
            seeMoreButton
            title={`Message from ${provider?.signature_name ?? "your provider"}`}
            note={note}
          />
        )}
        <QuestionAnswerLayout
          answerClassName="p-2"
          question={`Schedule a ${duration} appointment`}
          answer="Done"
        />
      </div>
    </div>
  );
};
